import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'

import useQueryGetBrokeFlexAnalytics from '../../api/hooks/useQueryGetBrokeFlexAnalytics'
import BrokeFlexAnalyticsOverviewCards from '../../components/BrokeFlexAnalyticsOverviewCards'
import BrokeFlexAnalyticsTable from '../../components/BrokeFlexAnalyticsTable'
import BrokeFlexOpensByDayWindowChart from '../../components/BrokeFlexOpensByDayWindowChart'

function BrokeFlexAnalyticsPage() {
	const { data, isLoading } = useQueryGetBrokeFlexAnalytics()

	return (
		<PageContainer>
			<div className="space-y-6">
				{/* Page Header */}
				<div>
					<h1 className="text-2xl font-bold tracking-tight">
						Broke-Flex Campaign Analytics
					</h1>
					<p className="text-muted-foreground">
						วิเคราะห์ประสิทธิภาพแคมเปญข้อความสำหรับผู้เล่นที่เงินหมด
					</p>
				</div>

				{/* Summary Section */}
				<Card>
					<CardHeader>
						<CardTitle>ภาพรวม (Overall)</CardTitle>
						<p className="text-sm text-muted-foreground">
							สถิติรวมจากแคมเปญ Broke-Flex ทั้งหมด
						</p>
					</CardHeader>
					<CardContent className="space-y-6">
						{/* Overview KPI Cards */}
						<BrokeFlexAnalyticsOverviewCards
							overall={data?.overall}
							isLoading={isLoading}
						/>

						{/* Opens by Day Window Chart */}
						<BrokeFlexOpensByDayWindowChart
							opensByDayWindow={data?.overall?.opensByDayWindow}
							isLoading={isLoading}
							title="การเปิดดูตามช่วงเวลา (รวมทุกแคมเปญ)"
						/>
					</CardContent>
				</Card>

				{/* Individual Campaigns Table */}
				<BrokeFlexAnalyticsTable
					data={data?.data || []}
					isLoading={isLoading}
				/>
			</div>
		</PageContainer>
	)
}

const GuardedBrokeFlexAnalyticsPage = withUserPermission(
	BrokeFlexAnalyticsPage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_SMS],
	},
)

export default GuardedBrokeFlexAnalyticsPage
